import { API_CACHE_KEYS } from "api/cacheKeys";
import { BaseQueryOptions } from "api/types";
import { useCustomQuery } from "api/useCustomQuery";
import { JANZU_URL } from "config/config";

export type GetImageQueriesAnswersByTypeParams = {
  detectorId?: string;
  answerType?: string;
};

type UseGetImageQueriesAnswersByTypeParams = {
  params?: GetImageQueriesAnswersByTypeParams;
  options?: BaseQueryOptions<GetImageQueriesAnswersByTypeResponse>;
};

type GetImageQueriesAnswersByTypeResponse = {
  answers: Array<any>;
};

function useGetImageQueriesAnswersByType({ params, options }: UseGetImageQueriesAnswersByTypeParams = {}) {
  const url = `${JANZU_URL}reef-api/image-queries/answers-by-type`;
  const searchParams = new URLSearchParams();

  if (params?.detectorId !== undefined) {
    searchParams.append("detector_id", params.detectorId);
  }

  if (params?.answerType !== undefined) {
    searchParams.append("answer_type", params.answerType);
  }

  return useCustomQuery<GetImageQueriesAnswersByTypeResponse>(
    API_CACHE_KEYS.imageQueries.answersByType(params),
    `${url}?${searchParams.toString()}`,
    options
  );
}

type UseImageQueriesAnswersByTypeParams = {
  getOptions?: {
    params?: GetImageQueriesAnswersByTypeParams;
    options?: BaseQueryOptions<GetImageQueriesAnswersByTypeResponse>;
  };
};

export function useImageQueriesAnswersByType({ getOptions }: UseImageQueriesAnswersByTypeParams = {}) {
  const imageQueriesAnswersByType = useGetImageQueriesAnswersByType({
    params: getOptions?.params,
    options: getOptions?.options,
  });

  return {
    // Get operations
    imageQueriesAnswersByType: imageQueriesAnswersByType.data,
    isLoadingImageQueriesAnswersByType: imageQueriesAnswersByType.isFetching,
    imageQueriesAnswersByTypeError: imageQueriesAnswersByType.error,
  };
}
